/**
 * Async chunk that carries the Adyen stylesheets.
 *
 * Co-locating the CSS imports in a JS module that we load via dynamic import() lets webpack
 * extract + inject them as part of the chunk. A bare CSS-only dynamic import
 * (`await import('@adyen/adyen-web/dist/adyen.css')`) is dropped by this webpack 4 / vue-cli
 * build, which is why the Card Component rendered with no base styles.
 *
 * This module intentionally does NOT static-import the SDK (`@adyen/adyen-web`): doing so pulls
 * the SDK through babel and injects a core-js polyfill this build can't resolve. The SDK stays a
 * separate dynamic import in adyenPayment.js. Both chunks are lazy, so non-adyen venues download
 * neither (D7).
 *
 * Note: adyen.css lives in node_modules, which vue.config.js excludes from postcss-pxtorem, so
 * Adyen's px sizes stay as-is and are immune to the amfe-flexible root font-size. adyenTheme.css
 * is imported last so our per-venue accent overrides win the cascade.
 */
import '@adyen/adyen-web/dist/adyen.css'
import './adyenTheme.css'
